import React from 'react';
import {
    Text,
    Theme
} from '@simplybenefits/sb-ui-library';
import { ChevronRight as ChevronRightIcon } from '@mui/icons-material';

const styles = {
    breadCrumbIcon: {
        color: Theme.colors.mediumGrey,
        marginRight: '5px',
        fontSize: '20px',
        marginTop: '2px'
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: '30px'
    },
    breadcrumbItem: {
        display: 'flex',
        alignItems: 'center'
    }
};

/**
 * BreadCrumbs component displays a breadcrumb navigation trail with clickable items.
 * The last item in the breadcrumb trail is highlighted using the whitelabel primary color.
 * @param {Array<Object>} props.breadcrumbs - Array of breadcrumb objects
 * @param {string} props.breadcrumbs[].title - Display text for the breadcrumb item
 * @param {string} [props.breadcrumbs[].link] - Optional URL link for the breadcrumb
 * @param {Function} [props.breadcrumbs[].onClick] - Optional click handler for the breadcrumb
 * @param {boolean} [props.breadcrumbs[].isHighlighted] - Whether this breadcrumb should be highlighted (typically the current page)
 * @param {Object} [props.whitelabel={}] - Whitelabel configuration object
 * @param {string} [props.whitelabel.primaryColor] - Primary color for highlighted breadcrumb (defaults to Theme.colors.skyBlue)
 * @returns {React.Element} Rendered breadcrumb navigation component
 */
const BreadCrumbs = ({
    breadcrumbs,
    whitelabel = {}
}) => {
    const highlightColor = whitelabel?.primaryColor || Theme.colors.skyBlue;

    return (
        <div style={styles.container}>
            {
                breadcrumbs.map((breadcrumb) => {
                    const { title, link, onClick, isHighlighted } = breadcrumb;
                    return (
                        <div key={title} style={styles.breadcrumbItem}>
                            <Text
                                onClick={onClick || null}
                                medium
                                margin="0px"
                                display="inline-block"
                                customStyle={{
                                    cursor: !isHighlighted ? 'pointer' : 'default',
                                    letterSpacing: '0.6px'
                                }}
                                link={link || null}
                                color={isHighlighted ? highlightColor : undefined}
                                bold={isHighlighted}
                            >
                                {title}
                            </Text>

                            {!isHighlighted && (
                                <ChevronRightIcon
                                    style={styles.breadCrumbIcon}
                                />
                            )}
                        </div>
                    );
                })
            }
        </div>
    );
};

export default BreadCrumbs;